import React, { Component } from 'react';

// Externals
import PropTypes from 'prop-types';
import axios from 'axios';
import compose from 'recompose/compose';
import { withRouter } from "react-router-dom";

// Material helpers
import { withStyles } from '@material-ui/core';

// Material components
import { Grid } from '@material-ui/core';

// Shared layouts
import { Application as ApplicationLayout } from 'layouts';

// components

import PropertyTabs from './components/PropertyTabs';

// Auth
// import AuthHelperMethods from 'components/Auth/AuthHelperMethods.jsx';
import withAuth from 'components/Auth/withAuth.jsx';

// Component styles
const styles = theme => ({
  root: {
    padding: theme.spacing.unit * 4
  },
  item: {
    height: '100%'
  }
});

class Property extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      propertyProfile: { id: '',
                     attributes: {}
                   },
    };
  }


  componentDidMount() {
    this._isMounted = true;
    const { match } = this.props;
    const confirm = this.props.confirm;
    const propertyId = Number(match.params.id);
    console.log(confirm);
    let url = `${process.env.REACT_APP_API_URL}deals/` + propertyId + '.json';
    axios
      .get(url,{headers:{ Authorization: 'Bearer ' + confirm }})
      .then(response => {
        if (this._isMounted) {
        this.setState({ propertyProfile: response.data.data });
        console.log(response.data.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { propertyProfile } = this.state;
    const { classes } = this.props;


    return (
      <ApplicationLayout title={`Deal ref: ${propertyProfile.id}`}>
        <div className={classes.root}>
          <Grid
            container
            spacing={8}
            justify="center"
          >

            <Grid
              item
              lg={12}
              md={12}
              xl={12}
              xs={12}
            >
            <PropertyTabs property={propertyProfile} />

            </Grid>

          </Grid>
        </div>
      </ApplicationLayout>
    );
  }
}

Property.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(
  withAuth,
  withStyles(styles),
  withRouter
)(Property);
